export default {
  learn_skill_list: [],
  plan_skill_list: [],
  goals_skill_list: [],
  rate_skill_list: [],
  skill_name: null,
  skill_description: [],
  plan_question_list: [],
  plan_answers: [],
  rate_question_list: [],
  practice_question_list: [],
  questions_to_skip: [],
  related_plan_answers: [],
  practice_answers: []
};
